import Vue from 'vue'
// Directives
import Allowed from './Allowed'
import Markdown from './Markdown'

// Usage
Vue.directive('allowed', Allowed)
Vue.directive('markdown', Markdown)

export default [Allowed, Markdown]
